import { AxiosRestApplicationClient as AgentNetworkAxiosRestApplicationClient } from '@g2-shared/api-client/generated/agentnetwork-app';
import {
  generateBaseAxiosClient,
  INotificationService,
  NotificationsService,
} from '@g2-shared/common';

// @ts-ignore
const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const AgentNetworkApiClient = new AgentNetworkAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);

interface DIContextInterface {
  NotificationService: () => INotificationService;
  AgentNetworkApiClient: AgentNetworkAxiosRestApplicationClient;
}

export const DIContext = (): DIContextInterface => ({
  NotificationService: NotificationsService,
  AgentNetworkApiClient,
});
